export default class ProfitBreakdown {
    _appreciation = 0;
    _rentalIncome = 0;
    _costOfVacancy = 0;
    _principalSavings = 0;
    _sellingCost = 0;
    _netProfit = 0;
    _netProfitWithAppreciation = 0;
    _roiPct = 0;
    _roiPctWithAppreciation = 0;

    set appreciation(value) {
        this._appreciation = Math.round(value);
    }

    get appreciation() {
        return this._appreciation;
    }

    set rentalIncome(value) {
        this._rentalIncome = Math.round(value);
    }

    get rentalIncome() {
        return this._rentalIncome;
    }

    set costOfVacancy(value) {
        this._costOfVacancy = Math.round(value);
    }

    get costOfVacancy() {
        return this._costOfVacancy;
    }

    set principalSavings(value) {
        this._principalSavings = Math.round(value);
    }

    get principalSavings() {
        return this._principalSavings;
    }

    set sellingCost(value) {
        this._sellingCost = Math.round(value);
    }

    get sellingCost() {
        return this._sellingCost;
    }

    set netProfit(value) {
        this._netProfit = Math.round(value);
    }

    get netProfit() {
        return this._netProfit;
    }

    set netProfitWithAppreciation(value) {
        this._netProfitWithAppreciation = Math.round(value);
    }

    get netProfitWithAppreciation() {
        return this._netProfitWithAppreciation;
    }

    set roiPct(value) {
        this._roiPct = Math.round(value);
    }

    get roiPct() {
        return this._roiPct;
    }

    set roiPctWithAppreciation(value) {
        this._roiPctWithAppreciation = Math.round(value);
    }

    get roiPctWithAppreciation() {
        return this._roiPctWithAppreciation;
    }
}